/* GHALIA — single source of truth for storefront pricing (mirrors Liquid format-money + vat-display-cents). */
(function () {
  window.Shopify = window.Shopify || {};

  function config() {
    return window.Shopify.moneyConfig || {};
  }

  /** Catalog / variant.price in cents (ex-VAT when taxes not included in admin). */
  function displayCents(netCents, skipVat) {
    var amount = Number(netCents) || 0;
    if (skipVat || config().taxesIncluded) return amount;
    var rate = Number(config().vatRate);
    if (!rate || rate <= 0) return amount;
    return Math.round((amount * (100 + rate)) / 100);
  }

  function vatRate() {
    return Number(config().vatRate) || 15;
  }

  function formatMoney(cents, options) {
    options = options || {};
    var display = displayCents(cents, options.skipVat);
    var locale = config().locale || 'en';
    var amount = (display / 100).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var code = config().currencyDisplay || config().currencyIso || 'SAR';
    if (config().currencyCodeEnabled) return amount + ' ' + code;
    return (config().currencySymbol || '') + amount;
  }

  function formatMoneyAmount(cents, options) {
    options = options || {};
    var display = displayCents(cents, options.skipVat);
    var locale = config().locale || 'en';
    return (display / 100).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  /** Customer-facing price from catalog net cents (PDP, cart lines, set rows). */
  function formatNet(netCents) {
    return formatMoney(netCents, { skipVat: false });
  }

  /** Format cents that are already customer-facing (cart summary lines after VAT split). */
  function formatDisplay(displayCentsValue) {
    return formatMoney(displayCentsValue, { skipVat: true });
  }

  function applyDiscount(netCents, pct) {
    var net = Number(netCents) || 0;
    var rate = Math.max(0, Math.min(100, Number(pct) || 0));
    return Math.round((net * (100 - rate)) / 100);
  }

  function applyDiscountDisplay(displayCentsValue, pct) {
    var gross = Number(displayCentsValue) || 0;
    var rate = Math.max(0, Math.min(100, Number(pct) || 0));
    return Math.round((gross * (100 - rate)) / 100);
  }

  function sumNet(prices) {
    return (prices || []).reduce(function (acc, p) {
      return acc + (Number(p) || 0);
    }, 0);
  }

  function setTotals(netPrices, discountPct) {
    var compareNet = sumNet(netPrices);
    var totalNet = discountPct > 0 ? applyDiscount(compareNet, discountPct) : compareNet;
    return {
      compareNet: compareNet,
      totalNet: totalNet,
      compareDisplay: displayCents(compareNet),
      totalDisplay: displayCents(totalNet),
    };
  }

  function vatOnNet(netCents) {
    return Math.round((Number(netCents) || 0) * vatRate() / 100);
  }

  function cartLineAmounts(item, row) {
    var netFromDom = Number(row?.dataset?.cartLineNet || 0);
    var displayFromDom = Number(row?.dataset?.cartLineDisplay || 0);
    var qty = Number(item?.quantity) || 1;
    var unitNet = Number(
      item?.final_price ?? item?.price ?? item?.original_price ?? 0
    );
    var lineNet = Number(item?.final_line_price || 0);
    if (!lineNet) lineNet = unitNet * qty;
    var net = netFromDom > 0 ? netFromDom : lineNet;
    if (item?.final_price != null && item?.final_line_price != null) {
      net = Number(item.final_line_price) || net;
      unitNet = Number(item.final_price) || unitNet;
    }
    var display = displayFromDom > 0 ? displayFromDom : displayCents(net);
    return { net: net, display: display, unitNet: unitNet };
  }

  var NATIVE_BUNDLE_HANDLES = window.GhaliaNativeBundleHandles || new Set([
    'ghalia-infinity-ring-duo',
    'knot-bridge-duo-silver',
    'knot-bridge-duo-gold',
    'ghalia-knot-hero-set-gold',
    'ghalia-knot-hero-set-silver',
    'ghalia-knot-two-tone-ring-stack',
    'ghalia-knot-wrist-story',
    'ghalia-pave-gold-stack',
    'ghalia-pave-silver-stack',
    'ghalia-cross-ring-earring-gold',
  ]);

  function isNativeBundleLine(item) {
    return Boolean(item && item.handle && NATIVE_BUNDLE_HANDLES.has(item.handle));
  }

  function isBundleLine(item) {
    return Boolean(item && item.properties && item.properties._ghalia_stack_anchor);
  }

  function isFreeGiftLine(item) {
    return Boolean(item && item.properties && item.properties._ghalia_free_gift === 'true');
  }

  function parseStacksFromCart(cart) {
    var stacks = new Map();
    (cart?.items || []).forEach(function (item) {
      if (isFreeGiftLine(item)) return;
      var anchor = item.properties && item.properties._ghalia_stack_anchor;
      var pct = parseInt(item.properties && item.properties._ghalia_stack_pct, 10) || 0;
      var membersRaw = (item.properties && item.properties._ghalia_stack_members) || '';
      if (!anchor || !pct || !membersRaw) return;
      var members = membersRaw.split(',').map(function (h) {
        return h.trim();
      }).filter(Boolean);
      if (!members.length) return;
      if (!stacks.has(anchor)) stacks.set(anchor, { anchor: anchor, pct: pct, members: members });
    });
    return Array.from(stacks.values());
  }

  function qtyByHandle(cart) {
    var map = new Map();
    (cart?.items || []).forEach(function (item) {
      if (isFreeGiftLine(item) || !item.handle) return;
      map.set(item.handle, (map.get(item.handle) || 0) + (Number(item.quantity) || 1));
    });
    return map;
  }

  function bundleDiscountedQtyMap(cart) {
    var stacks = parseStacksFromCart(cart);
    var qty = qtyByHandle(cart);
    var discounted = new Map();
    stacks.forEach(function (stack) {
      var present = stack.members.every(function (h) {
        return (qty.get(h) || 0) > 0;
      });
      if (!present) return;
      var setCount = Math.min.apply(
        null,
        stack.members.map(function (h) {
          return qty.get(h) || 0;
        })
      );
      if (setCount <= 0) return;
      stack.members.forEach(function (h) {
        discounted.set(h, Math.max(discounted.get(h) || 0, setCount));
      });
    });
    return discounted;
  }

  /** Bundle set units per cart line — caps discount to min(qty) across members. */
  function bundleUnitsByLineKey(cart) {
    var perHandle = bundleDiscountedQtyMap(cart);
    var remaining = new Map();
    perHandle.forEach(function (count, handle) {
      remaining.set(handle, count);
    });
    var byKey = new Map();
    (cart?.items || []).forEach(function (item) {
      if (isFreeGiftLine(item) || !item.handle) return;
      var left = remaining.get(item.handle) || 0;
      var qty = Number(item.quantity) || 1;
      var setUnits = Math.min(qty, left);
      byKey.set(item.key, setUnits);
      remaining.set(item.handle, left - setUnits);
    });
    return byKey;
  }

  /** Promos / global discount — ex-VAT; bundle set units excluded, extra qty counts. */
  function qualifyingSubtotalNet(cart, drawer) {
    var unitsByLine = bundleUnitsByLineKey(cart);
    var memberHandles = new Set();
    parseStacksFromCart(cart).forEach(function (stack) {
      stack.members.forEach(function (h) {
        memberHandles.add(h);
      });
    });
    var total = 0;
    (cart?.items || []).forEach(function (item) {
      if (isFreeGiftLine(item) || isNativeBundleLine(item)) return;
      var row = drawer && drawer.querySelector('[data-cart-line-key="' + item.key + '"]');
      var amounts = cartLineAmounts(item, row);
      var qty = Number(item.quantity) || 1;
      var unitNet = amounts.unitNet > 0 ? amounts.unitNet : Math.round(amounts.net / qty);
      var setUnits = unitsByLine.get(item.key) || 0;
      var regularUnits = qty - setUnits;
      if (regularUnits > 0) total += unitNet * regularUnits;
      else if (!memberHandles.has(item.handle)) total += amounts.net;
    });
    return total;
  }

  window.Shopify.displayCents = displayCents;
  window.Shopify.formatMoney = formatMoney;
  window.Shopify.formatMoneyAmount = formatMoneyAmount;

  window.GhaliaPricing = {
    config: config,
    vatRate: vatRate,
    displayCents: displayCents,
    formatNet: formatNet,
    formatDisplay: formatDisplay,
    applyDiscount: applyDiscount,
    applyDiscountDisplay: applyDiscountDisplay,
    sumNet: sumNet,
    setTotals: setTotals,
    vatOnNet: vatOnNet,
    cartLineAmounts: cartLineAmounts,
    isBundleLine: isBundleLine,
    isNativeBundleLine: isNativeBundleLine,
    isFreeGiftLine: isFreeGiftLine,
    qualifyingSubtotalNet: qualifyingSubtotalNet,
    bundleUnitsByLineKey: bundleUnitsByLineKey,
    bundleDiscountedQtyMap: bundleDiscountedQtyMap,
  };
})();
